<template>
  <div class="asset-med-rev" v-if="showSection">
    <div
      class="reviewer-info"
      :data-chronicle="chronicId"
      data-e2e="asset-medical-review"
      v-metric="{ module: metrics.module}"
      :class="{
				'slideshowMedReview': slideshowMedReview,
				'interactiveMedReview': interactiveMedReview
			}"
      v-if="(primaryReviewer && primaryReviewer.name) || (secondaryReviewer
						&& secondaryReviewer.name)"
    >
      <span v-if="primaryReviewer.photo" class="reviewer-photo-cont">
        <figure>
            <img :src="primaryReviewerImage" class="reviewer-photo" />
        </figure>
      </span>
      <span
        class="reviewer-txt"
        :class="{'seperatorLine': (((authorData && (authorData.author || authorData.secondAuthor) &&
								(authorData.author.length > 0 ||
									authorData.secondAuthor.length > 0)) || showWebMDContrib) && contentType !== 'video')
						}"
      >
        {{ translation(reviewer) }}
        <a
          v-if="primaryReviewer
						&& primaryReviewer.name
						&& primaryReviewer.bioUrl"
          class="person"
          :href="primaryReviewer.bioUrl"
          v-metric="{ link: 0 }"
        >
          {{ primaryReviewer.name }}
        </a>
        <span
          class="no-link"
          v-else-if="primaryReviewer && !primaryReviewer.bioUrl"
        >
          {{ primaryReviewer.name }}
        </span>
        <span v-if="secondaryReviewer.name"> and </span>
        <a
          v-if="secondaryReviewer
						&& secondaryReviewer.name
						&& secondaryReviewer.bioUrl"
          class="person"
          :href="secondaryReviewer.bioUrl"
          v-metric="{ link: 0 }"
        >
          {{ secondaryReviewer.name }}
        </a>
        <span
          class="no-link"
          v-else-if="secondaryReviewer && !secondaryReviewer.bioUrl"
        >
          {{ secondaryReviewer.name }}
        </span>
        <span class="revDate" v-if="formattedDate">
           {{ formattedDate }}
        </span>
      </span>
    </div>
    <div class="byline" v-if="contentType !== 'video'">
      <span
        v-if="authorData && (authorData.author || authorData.secondAuthor) &&
								(authorData.author.length > 0 ||
									authorData.secondAuthor.length > 0)"
      >
        <!-- eslint-disable -->
        <span class="authors" v-metric="{ module: 'wrtnby-lnk'}">
         {{ translation('Written by') }} 
          <template v-for="(item, index) in authorData.author">
            <a
              v-if="item.authorHrefName"
              :href="item.authorHrefName"
              class="person"
              :key="index"
              v-metric="{ link: index }"
              >{{ item.name }}</a
            >
            <span
              class="person"
              :key="index"
              v-if="!item.authorHrefName"
              >{{ item.name }}</span
            >
            <template
              v-if="authorData.author.length > 0
											&& index!==(authorData.author.length-1)"
              >,&nbsp;</template
            >
          </template>
          <template
            v-if="authorData.author.length > 0 &&
										authorData.secondAuthor.length > 0"
            >,&nbsp;</template
          >
          <template v-for="(item, index) in authorData.secondAuthor">
            <a
              v-if="item.authorHrefName"
              :href="item.authorHrefName"
              class="person"
              :key="index"
              v-metric="{ link: index }"
              >{{ item.name }}</a
            >
            <span
              class="person"
              :key="index"
              v-if="!item.authorHrefName"
              >{{ item.name }}</span
            >
            <template
              v-if="authorData.secondAuthor.length > 0
											&& index!==(authorData.secondAuthor.length-1)"
              >,&nbsp;</template
            >
          </template>
        </span>
        <!--eslint-enable-->
      </span>
      <span v-else-if="showWebMDContrib">
        <span class="authors">
          {{ translation('Written by') }}
          <a
            href="https://www.webmd.com/webmd-editorial-contributors"
            class="person"
            :key="index"
			v-metric="{ module: 'wrtnbyedit-lnk'}"
          >
            {{ translation('WebMD Editorial Contributors') }}
          </a>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

/* eslint no-underscore-dangle: [2, {
	"allow": [
		"_targetUrl",
		"_chronic_id"]
}] */

import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';
import { getTranslationData } from './helpers/translations.es6';

export default {
	name: 'WebMdMedicalReview',
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		contentType: {
			type: String,
		},

	},

	data() {
		return {
			metrics: {
				module: 'rvdby-lnk',
			},
			moduleData: {},
			publication: 'WebMD Medical Reference',
			reviewer: 'Medically Reviewed by',
			primaryReviewer: {},
			secondaryReviewer: {},
			formattedDate: null,
			slideshowMedReview: false,
			interactiveMedReview: false,
			authorData: {},
			primaryReviewerImage:'',
			localLang: '',
		};
	},

	computed: {
		getModuleData() {
			return this.store.cms.getModules('articleModule') || this.store.cms.getModules(this.chronicId);
		},
		getPrimReviewerDetails() {
			let reviewer = {};

			if (_has(this.moduleData, 'module_settings.metadata_section.wbmd_prim_med_revr')) {
				reviewer = (this.moduleData.module_settings.metadata_section.wbmd_prim_med_revr || {});
				// eslint-disable-next-line max-len
				const moduleObj = (this.moduleData.module_settings.metadata_section.wbmd_prim_med_revr || {});
				reviewer.name = this.getName(moduleObj);
				reviewer.photo = this.getPhoto(moduleObj);
				if (moduleObj) {
					// eslint-disable-next-line no-nested-ternary
					reviewer.bioUrl = _has(moduleObj, 'wbmd_bio_obj_id.link_friendlyurl') ? moduleObj.wbmd_bio_obj_id.link_friendlyurl
						: _has(moduleObj, 'wbmd_person.wbmd_bio_obj_id.link_friendlyurl') ? moduleObj.wbmd_person.wbmd_bio_obj_id.link_friendlyurl : '';

				}
			}
			return reviewer;
		},
		getSecReviewerDetails() {
			let reviewer = {};
			if (_has(this.moduleData, 'module_settings.metadata_section.wbmd_c_sec_med_revr')) {
				reviewer = (this.moduleData.module_settings.metadata_section.wbmd_c_sec_med_revr || {});
				// eslint-disable-next-line max-len
				const moduleObj = (this.moduleData.module_settings.metadata_section.wbmd_c_sec_med_revr || {});
				if (reviewer) {
					reviewer.name = this.getName(moduleObj);
					// eslint-disable-next-line no-nested-ternary
					reviewer.bioUrl = _has(moduleObj, 'wbmd_bio_obj_id.link_friendlyurl') ? moduleObj.wbmd_bio_obj_id.link_friendlyurl
						: _has(moduleObj, 'wbmd_person.wbmd_bio_obj_id.link_friendlyurl') ? moduleObj.wbmd_person.wbmd_bio_obj_id.link_friendlyurl : '';
				}
			}
			return reviewer;
		},

		getAuthorDataDetail() {
			const metadata = this.moduleData;


			const author = metadata && (_has(metadata, 'module_settings.metadata_section.wbmd_authr_prim_group.wbmd_authr_prim') ? this.getAuthorDetails(metadata.module_settings.metadata_section.wbmd_authr_prim_group.wbmd_authr_prim) : []);
			const secondAuthor = metadata && (_has(metadata, 'module_settings.metadata_section.wbmd_c_sec_authr_group.wbmd_c_sec_authr') ? this.getAuthorDetails(metadata.module_settings.metadata_section.wbmd_c_sec_authr_group.wbmd_c_sec_authr) : []);

			return {
				author,
				secondAuthor,
			};
		},

		isSiteFronts() {
			const sfData = this.store.cms.siteFronts;
			if (_has(sfData, 'mode')) {
				return sfData.mode.toLowerCase() === 'sitefronts';
			}
			return false;
		},

		getMetaData() {
			const module = this.moduleData;

			const metadata = module && _has(module, 'module_settings.metadata_section')
				? module.module_settings.metadata_section : {};
			return metadata;
		},

		isPolicyCorp() {
			const metaData = this.metadataModule;
			const pubName = metaData && _has(metaData, 'wbmd_publ.wbmd_publ_name')
				? metaData.wbmd_publ.wbmd_publ_name : '';
			const pubNames = ['WebMD Policy', 'WebMD Corporate', 'WebMD Press Release', 'WebMD Policy - Spanish'];

			return pubNames.includes(pubName);
		},

		showWebMDContrib() {
			const metaData = this.metadataModule;
			const busRef = metaData && _has(metaData, 'wbmd_bus_ref.wbmd_disp_nm')
				? metaData.wbmd_bus_ref.wbmd_disp_nm : '';
			const busRefNames = ['Medical Reference', 'Medical Reference - Drug', 'Product A-Z'];

			return busRefNames.includes(busRef) && !this.isPolicyCorp;
		},

		showSection() {
			const showReviewsection = ((this.primaryReviewer && this.primaryReviewer.name) || (this.secondaryReviewer
						&& this.secondaryReviewer.name)) ? true : false;
			const byline = (this.authorData && (this.authorData.author || this.authorData.secondAuthor) &&
								(this.authorData.author.length > 0 ||
									this.authorData.secondAuthor.length > 0)) || this.showWebMDContrib ? true : false;
			if (showReviewsection || byline) {
				return true;
			} else {
				return false;
			}
		}	

	},

	created() {
		this.store = useStore(this.$pinia);
		this.localLang = this.store?.pagedata?.omniture?.s_language_locale;
		this.moduleData = this.getModuleData;
		this.metadataModule = this.getMetaData;
		this.primaryReviewer = this.getPrimReviewerDetails;
		if (this.primaryReviewer && this.primaryReviewer.photo) {
			this.primaryReviewerImage = `${this.primaryReviewer.photo}?resize=51px:51px&output-quality=75`;	
			this.store.cms.appendPreLoadData({ url: `${this.primaryReviewerImage}`, type: 'image' });
		}
		this.secondaryReviewer = this.getSecReviewerDetails;
		this.formattedDate = this.getReviewDate();
		this.authorData = this.getAuthorDataDetail;

		if (this.isSiteFronts) {
			if (this.$capId === '091e9c5e814695f1') {
				this.slideshowMedReview = true;
			}
			if (this.$capId === '091e9c5e8151ce94' || this.$capId === '091e9c5e8151db4c') {
				this.interactiveMedReview = true;
			}
			this.reviewer = 'Reviewed by';
		}
	},

	methods: {
		getName(moduleObj) {
			// eslint-disable-next-line no-nested-ternary
			let firstName = _has(moduleObj, 'wbmd_first_nm') ? moduleObj.wbmd_first_nm
				: _has(moduleObj, 'wbmd_person.wbmd_first_nm') ? moduleObj.wbmd_person.wbmd_first_nm : '';
			if (!firstName) {
				firstName = '';
			}
			// eslint-disable-next-line no-nested-ternary
			let middleName = _has(moduleObj, 'wbmd_middle_name') ? moduleObj.wbmd_middle_name
				: _has(moduleObj, 'wbmd_person.wbmd_middle_name') ? moduleObj.wbmd_person.wbmd_middle_name : '';
			if (!middleName) {
				middleName = '';
			}
			// eslint-disable-next-line no-nested-ternary
			let lastName = _has(moduleObj, 'wbmd_lst_nm') ? moduleObj.wbmd_lst_nm
				: _has(moduleObj, 'wbmd_person.wbmd_lst_nm') ? moduleObj.wbmd_person.wbmd_lst_nm : '';
			if (!lastName) {
				lastName = '';
			}
			// eslint-disable-next-line no-nested-ternary
			const suffixData = _has(moduleObj, 'wbmd_person_suffix_group.wbmd_person_suffix') ? moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
				: _has(moduleObj, 'wbmd_person.wbmd_person_suffix_group.wbmd_person_suffix') ? moduleObj.wbmd_person.wbmd_person_suffix_group.wbmd_person_suffix : '';

			let nameRes = '';
			let suffix = '';
			if (suffixData && _isArray(suffixData)) {
				suffixData.forEach((x) => {
					if (!firstName && !middleName && !lastName) {
						suffix += `\u00A0${x.wbmd_disp_nm}`;
					} else {
						suffix += `,\u00A0${x.wbmd_disp_nm}`;
					}
				});
			} else if (suffixData && _isObject(suffixData)) {
				if (!firstName && !middleName && !lastName) {
					suffix = `\u00A0${suffixData.wbmd_disp_nm}` || '';
				} else {
					suffix = `,\u00A0${suffixData.wbmd_disp_nm}` || '';
				}
			}

			nameRes = (`${firstName}${middleName}${lastName}${suffix}`).length > 0 ? `${firstName} ${middleName} ${lastName}`.trim() + suffix : null;
			return nameRes;
		},

		getPhoto(moduleObj) {
			 // add photo if available
			  const imageBaseUrl = this.store?.pagedata?.omniture?.image_server_url;
			if (_has(moduleObj, 'wbmd_bio_obj_id.content_section.cons_bio.person_photo.path')
				&& moduleObj.wbmd_bio_obj_id.content_section.cons_bio.person_photo.path !== '/webmd/consumer_assets') {
				let reviewerImg = `${imageBaseUrl}${moduleObj.wbmd_bio_obj_id.content_section.cons_bio.person_photo.path}`;
				return reviewerImg;
			}

		},
		getReviewDate() {
			let reviewDate = '';
			if (_has(this.moduleData, 'module_settings.metadata_section')) {
				const metaDataSec = this.moduleData.module_settings.metadata_section;
				let primReviewDate = null;
				let secondReviewDate = null;

				if (metaDataSec) {
					primReviewDate = metaDataSec.wbmd_prim_revw_dt ? new Date((` ${metaDataSec.wbmd_prim_revw_dt}`)) : null;
					secondReviewDate = metaDataSec.wbmd_c_sec_med_revw_dt ? new Date((` ${metaDataSec.wbmd_c_sec_med_revw_dt}`)) : null;

					// Date(null) will result in Invalid date error so changed the date conditions above
					if (primReviewDate) {
						if (secondReviewDate) {
							// eslint-disable-next-line max-len
							reviewDate = (primReviewDate > secondReviewDate) ? this.formatDate(primReviewDate) : this.formatDate(secondReviewDate);
						}
						reviewDate = this.formatDate(primReviewDate);
					}
				}
			}
			return reviewDate;
		},
		formatDate(date) {
			const monthNames = [
				'January', 'February', 'March',
				'April', 'May', 'June', 'July',
				'August', 'September', 'October',
				'November', 'December',
			];

			let day = date.getDate();
			const monthIndex = date.getMonth();
			const year = date.getFullYear();

			day = (day > 9) ? day : (`0${day}`);
			this.formattedDate = monthNames[monthIndex] && day && year && ` on ${monthNames[monthIndex]} ${day}, ${year}`;
			if (this.localLang === 'es_ES') {
				this.formattedDate = ` en ${this.translation(monthNames[monthIndex])} ${day} del ${year}`;
			}

			return this.formattedDate;
		},

		getAuthorDetails(authorsData) {
			if (!authorsData) {
				return [];
			}
			let authorArray;
			const authors = [];

			if (_isArray(authorsData)) {
				authorArray = authorsData;
			} else if (_isObject(authorsData)) {
				authorArray = [];
				/* eslint-disable no-unused-vars */
				const obj = JSON.stringify(authorsData, (key, value) => {
					authorArray.push(value);
				});
				/* eslint-enable no-unused-vars */
			}
			if (authorArray) {
				authorArray.forEach((auth) => {
					const authorObject = {
						name: this.getAuthName(auth).trim(),
						authorHrefName: auth.wbmd_bio_obj_id
							&& _has(auth, 'wbmd_bio_obj_id.link_friendlyurl')
							? auth.wbmd_bio_obj_id.link_friendlyurl : '',
					};
					if (authorObject && authorObject.name) {
						authors.push(authorObject);
					}
				});
			}
			return authors;
		},

		getAuthName(moduleObj) {
			const firstName = (moduleObj.wbmd_first_nm ? moduleObj.wbmd_first_nm.trim() : '');
			const middleName = (moduleObj.wbmd_middle_name ? moduleObj.wbmd_middle_name.trim() : '');
			const lastName = (moduleObj.wbmd_lst_nm ? moduleObj.wbmd_lst_nm.trim() : '');
			let suffixGroup;
			let suffixList;
			let suffix;

			if (_has(moduleObj, 'wbmd_person_suffix_group.wbmd_person_suffix')
				&& _isArray(moduleObj.wbmd_person_suffix_group.wbmd_person_suffix)) {
				suffixGroup	= moduleObj.wbmd_person_suffix_group.wbmd_person_suffix.length > 0
					? moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
					: [];
			} else if (_has(moduleObj, 'wbmd_person_suffix_group.wbmd_person_suffix')
			&& _isObject(moduleObj.wbmd_person_suffix_group.wbmd_person_suffix)) {
				suffixGroup = moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
					? moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
					: [];
			}

			if (_isArray(suffixGroup)) {
				suffixList = suffixGroup.length > 0
					? suffixGroup.map(item => item.wbmd_disp_nm.trim())
					: [];
			} else if (_isObject(suffixGroup)) {
				suffixList	= suffixGroup ? suffixGroup.wbmd_disp_nm.trim()
					: [];
			} else {
				suffixList = [];
			}

			if (_isArray(suffixList)) {
				suffix = suffixList.length > 0
					? suffixList.join(', ')
					: [];
			} else if (suffixList) {
				suffix = suffixList ? suffixList : [];
			}

			return `${firstName}${middleName.length > 0 ? ` ${middleName}` : ''} ${lastName}${suffixList.length > 0 ? `, ${suffix}` : ''}`;
		},

		translation(text) {
            return getTranslationData(this.localLang , text) || text; 
        },

	},
};
</script>

<style lang="scss" src="./stylesheets/component.scss"></style>
